import api from './api'

const services = {
    create(data) {
        return api().post('notifications', data)
    },
    list(search) {
        return api().get(`notifications${search ? search : ''}`)
    },
    adminList(search) {
        return api().get(`notifications/admin${search ? search : ''}`)
    },
    unreadCount() {
        return api().get('notifications/unread-count')
    },
    markRead(id) {
        return api().patch(`notifications/${id}/read`)
    },
    markAllRead() {
        return api().patch('notifications/read-all')
    },
    remove(id) {
        return api().delete(`notifications/${id}`)
    }
}

export default services
